import type { GameEvent } from './game-state';

type Listener = (timestamp: number) => void;

export class InputBus {
  private listeners: Map<GameEvent, Set<Listener>> = new Map();

  on(event: GameEvent, fn: Listener): () => void {
    if (!this.listeners.has(event)) this.listeners.set(event, new Set());
    this.listeners.get(event)!.add(fn);
    return () => this.off(event, fn);
  }

  off(event: GameEvent, fn: Listener): void {
    this.listeners.get(event)?.delete(fn);
  }

  emit(event: GameEvent, timestamp: number = performance.now()): void {
    this.listeners.get(event)?.forEach((fn) => fn(timestamp));
  }
}

export const inputBus = new InputBus();
